import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../models/user.model';

export const roleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const requiredRoles = route.data?.['roles'] as UserRole[] | undefined;

  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  const user = authService.currentUser();

  if (user && requiredRoles.includes(user.role)) {
    return true;
  }

  if (user) {
    router.navigate([authService.getRedirectRouteForRole(user.role)]);
  } else {
    router.navigate(['/login']);
  }

  return false;
};
